export function getStringToCharacters(givenStr = null) {
    if ( !givenStr ) return;

    // sanitize string
    givenStr = givenStr.trim();
    givenStr = givenStr.replace(/<[^>]*>/g, '');

    // string to array
    const arrText = givenStr.split('');
    let newText = '';

    arrText.forEach((item, index) => {
        // first item
        if ( 0 == index ) {
            newText += '<span class="word">';
        }

        // all items
        if ( item != ' ' ) {
            newText += `<span class="char">${item}</span>`;
        } else {
            newText += '</span> <span class="word">';
        }

        // last item
        if ( arrText.length - 1 == index ) {
            newText += '</span>';
        }
    });

    return newText;
}

export function getStringToWords(givenStr = null, wrapWord = false) {
    if ( !givenStr ) return;

    // sanitize string
    givenStr = givenStr.trim();
    givenStr = givenStr.replace(/<[^>]*>/g, '');
    
    const arrText = givenStr.split(' ');
    let newText = '';

    arrText.forEach((item) => {
        newText += '<span class="word">';
        newText += (wrapWord) ? `<span>${item}</span>` : item;
        newText += '</span> ';
    });

    return newText;
}



// ============================================================
// Characters Active
// ============================================================

const CHAR_TIMEOUTS_KEY = '__charTimeouts';

function clearCharAnimationTimeouts($parent) {
    if (!$parent) return;
    const timeouts = $parent[CHAR_TIMEOUTS_KEY];

    if (!timeouts?.length) return;

    timeouts.forEach(timeoutId => clearTimeout(timeoutId));
    $parent[CHAR_TIMEOUTS_KEY] = [];
}

function storeCharAnimationTimeout($parent, timeoutId) {
    if (!$parent) return;

    if (!$parent[CHAR_TIMEOUTS_KEY]) {
        $parent[CHAR_TIMEOUTS_KEY] = [];
    }

    $parent[CHAR_TIMEOUTS_KEY].push(timeoutId);
}


function calcCharDurationInterval($parent, duration) {
    if (!$parent || !duration) return 1000;

    const $chars = $parent.querySelectorAll('.char');
    const charCount = $chars.length || 0;

    return duration / charCount;
}


export function stringCharactersAddActive($parent = null, options = {interval: null, duration: null}) {
    if (!$parent) return;

    let interval = options.interval || 10;

    if ( options.duration ) {
        interval = calcCharDurationInterval($parent, options.duration);
    }

    clearCharAnimationTimeouts($parent);

    const $chars = $parent.querySelectorAll('.char');
    let charTimeout = 0;

    if (!$chars.length) return;

    $chars.forEach($char => {
        charTimeout = charTimeout + interval;

        const timeoutId = setTimeout(function(){
            $char.classList.add('active');
        }, charTimeout);

        storeCharAnimationTimeout($parent, timeoutId);
    });
}


export function stringCharactersRemoveActive($parent = null, options = {interval: null, duration: null}) {
    if (!$parent) return;

    let interval = options.interval || 10;

    if ( options.duration ) {
        interval = calcCharDurationInterval($parent, options.duration);
    }

    clearCharAnimationTimeouts($parent);

    const $chars = $parent.querySelectorAll('.char');
    let charTimeout = 0 - interval;

    if (!$chars.length) return;

    $chars.forEach($char => {
        charTimeout = charTimeout + interval;

        const timeoutId = setTimeout(function(){
            $char.classList.remove('active');
        }, charTimeout);

        storeCharAnimationTimeout($parent, timeoutId);
    });
}


export function stringCharactersRemoveActiveReverse($parent = null, options = {interval: null, duration: null}) {
    if (!$parent) return;

    let interval = options.interval || 10;

    if ( options.duration ) {
        interval = calcCharDurationInterval($parent, options.duration);
    }

    clearCharAnimationTimeouts($parent);

    const $chars = Array.from($parent.querySelectorAll('.char')).reverse();
    let charTimeout = 0 - interval;

    if (!$chars.length) return;

    $chars.forEach($char => {
        charTimeout = charTimeout + interval;

        const timeoutId = setTimeout(function(){
            $char.classList.remove('active');
        }, charTimeout);

        storeCharAnimationTimeout($parent, timeoutId);
    });
}



// ============================================================
// Words Active
// ============================================================

const WORD_TIMEOUTS_KEY = '__wordTimeouts';

function clearWordAnimationTimeouts($parent) {
    if (!$parent) return;
    const timeouts = $parent[WORD_TIMEOUTS_KEY];

    if (!timeouts?.length) return;

    timeouts.forEach(timeoutId => clearTimeout(timeoutId));
    $parent[WORD_TIMEOUTS_KEY] = [];
}

function storeWordAnimationTimeout($parent, timeoutId) {
    if (!$parent) return;

    if (!$parent[WORD_TIMEOUTS_KEY]) {
        $parent[WORD_TIMEOUTS_KEY] = [];
    }

    $parent[WORD_TIMEOUTS_KEY].push(timeoutId);
}


function calcWordDurationInterval($parent, duration) {
    if (!$parent || !duration) return 1000;

    const $words = $parent.querySelectorAll('.word');
    const wordCount = $words.length || 0;

    return duration / wordCount;
}


export function stringWordsAddActive($parent = null, options = {interval: null, duration: null}) {
    if (!$parent) return;

    let interval = options.interval || 10;

    if ( options.duration ) {
        interval = calcWordDurationInterval($parent, options.duration);
    }

    clearWordAnimationTimeouts($parent);

    const $words = $parent.querySelectorAll('.word');
    let wordTimeout = 0;

    if (!$words.length) return;

    $words.forEach($word => {
        wordTimeout = wordTimeout + interval;

        const timeoutId = setTimeout(function(){
            $word.classList.add('active');
        }, wordTimeout);

        storeWordAnimationTimeout($parent, timeoutId);
    });
}


export function stringWordsRemoveActive($parent = null, options = {interval: null, duration: null}) {
    if (!$parent) return;

    let interval = options.interval || 10;

    if ( options.duration ) {
        interval = calcWordDurationInterval($parent, options.duration);
    }

    clearWordAnimationTimeouts($parent);

    const $words = $parent.querySelectorAll('.word');
    let wordTimeout = 0 - interval;

    if (!$words.length) return;

    $words.forEach($word => {
        wordTimeout = wordTimeout + interval;

        const timeoutId = setTimeout(function(){
            $word.classList.remove('active');
        }, wordTimeout);

        storeWordAnimationTimeout($parent, timeoutId);
    });
}